import type { FC } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

export const Receipt: FC<SvgIconProps> = (props) => (
  <SvgIcon width="24" height="24" {...props}>
    <path d="M19.5 3.5L18 2l-1.5 1.5L15 2l-1.5 1.5L12 2l-1.5 1.5L9 2 7.5 3.5 6 2 4.5 3.5 3 2v20l1.5-1.5L6 22l1.5-1.5L9 22l1.5-1.5L12 22l1.5-1.5L15 22l1.5-1.5L18 22l1.5-1.5L21 22V2l-1.5 1.5zM19 19.09H5V4.91h14v14.18zM6 15h12v2H6v-2zm0-4h12v2H6v-2zm0-4h12v2H6V7z" />
  </SvgIcon>
)
